import React, { useState } from "react";
import { Button, Form } from "react-bootstrap";
import Select from "react-select";
import "./Blind_Sample_From.css";
import { faCirclePlus, faUpload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function Blind_Sample_From({ onProceed }) {
  const testTypeOptions = [
    { value: "repeatability", label: "Repeatability Test" },
    { value: "accuracy", label: "Accuracy Test" },
  ];

  const checkByOptions = [
    { value: "rahul", label: "Rahul Mali" },
    { value: "amit", label: "Amit Verma" },
  ];

  const [observations, setObservations] = useState(["", ""]);

  const handleObservationChange = (index, value) => {
    const updated = [...observations];
    updated[index] = value;
    setObservations(updated);
  };

  return (
    <section className="Legal_Entity_Form">
      <div className="white_container customer_section">
        <div className="row">
          {/* Test Type */}
          <div className="col-md-4">
            <Form.Group className="form_group">
              <Form.Label>Test Type</Form.Label>
              <Select
                options={testTypeOptions}
                placeholder="Select Test Type"
                classNamePrefix="react_select"
              />
            </Form.Group>
          </div>

          {/* Certified Value */}
          <div className="col-md-4">
            <Form.Group className="form_group">
              <Form.Label>Certified Value</Form.Label>
              <Form.Control placeholder="Certified Value" />
            </Form.Group>
          </div>
        </div>

        {/* Observations */}
        <div className="inner_form_section_holder">
          <div className="">
            <div className="heading_add_text">
              <div>
                <Form.Group className="form_group">
                  <Form.Label>Enter Observation</Form.Label>
                </Form.Group>
              </div>
              <div className="add_another_holder">
                <div>
                  <span>
                    <FontAwesomeIcon icon={faCirclePlus} /> Add Another Document
                  </span>
                </div>
              </div>
            </div>

            <div className="row">
              {observations.map((obs, index) => (
                <div
                  key={index}
                  className="col-xxl-1 col-xl-1 col-lg-2 col-md-3"
                >
                  <div className="observation_box">
                    <div className="obs_label">
                      OBS {String(index + 1).padStart(2, "0")}
                    </div>
                    <div className="form_field_holder">
                      <Form.Control
                        value={obs}
                        onChange={(e) =>
                          handleObservationChange(index, e.target.value)
                        }
                      />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="row mt-3">
            {/* Test Method */}
            <div className="col-md-4">
              <Form.Group className="form_group">
                <Form.Label>Test Method</Form.Label>
                <Form.Control placeholder="Enter Test Method" />
              </Form.Group>
            </div>

            {/* Average */}
            <div className="col-md-4">
              <Form.Group className="form_group">
                <Form.Label>Average</Form.Label>
                <Form.Control placeholder="Average" />
              </Form.Group>
            </div>
          </div>

          <div className="row">
            {/* Attach File */}
            <div className="col-md-4">
              <Form.Group className="form_group file_field">
                <Form.Label>Attach File </Form.Label>
                <div className="absolute_fields">
                  <Form.Control placeholder="Upload File" />
                  <div className="upload_icon_holder">
                    <FontAwesomeIcon icon={faUpload} className="upload_icon" />
                  </div>
                </div>
              </Form.Group>
            </div>

            {/*Tested By*/}
            <div className="col-md-4">
              <Form.Group className="form_group">
                <Form.Label>Tested By</Form.Label>
                <Select
                  options={checkByOptions}
                  placeholder="Select Tested By"
                  classNamePrefix="react_select"
                />
              </Form.Group>
            </div>
          </div>
        </div>

        {/* Footer Buttons */}
        <div className="permission_btn_holder">
          <Button className="permission_btn No_btn">Cancel</Button>
          <Button className="permission_btn Yes_btn" onClick={onProceed}>
            Save
          </Button>
        </div>
      </div>
    </section>
  );
}

export default Blind_Sample_From;
